module.exports = function() {
  return new Worker(__webpack_public_path__ + "4231c72f10c027f18503.worker.js");
};